<div class="fixed top-4 right-4 z-[9999] print:hidden">
  <ed-localization-icon-button></ed-localization-icon-button>
</div>
<router-outlet></router-outlet>

<div class="fixed bottom-4 right-4 z-[9999] print:hidden">
  <ed-privacy-consent-icon-button></ed-privacy-consent-icon-button>
</div>
